import React, { useEffect, useState } from 'react'
//import './style.css'
import axios from 'axios';
import Loading from '../images/sprite/loading40.gif'
import Transparent from '../images/sprite/transparent.gif'

export default function AccountStatement(props) {
   const [Agentid, setAgentid] = useState('');
   const [Coin, setCoin] = useState('');
   const [FixLimit, setFixLimit] = useState('');
   const [CurrentTime, setCurrentTime] = useState('')
   const [accountStatement, setaccountStatement] = useState([])

   useEffect(() => {

      axios.post('https://luckybdt.live/clientapi/accountstatement', {
         id: props.userid,
         token: props.utoken,

      })
         .then(result => {


            setaccountStatement(result.data)

            //console.log(result);
            //setAgentid(result.data[0].agentId);
            //setCoin(result.data[0].coin);
            //setFixLimit(result.data[0].fixLimit);
            //setCurrentTime(result.data[0].timeCurr);



         }

         ).catch(e => {
            //setIsError(true);
         });

   }, [])

   return (
      <React.Fragment>


         <div class="col-left">

            <div class="sub_path">

               <div class="path">
                  <ul   >
                     <li class="path-last"><a >My Account</a></li>
                  </ul>
               </div>
               <ul id="sports-path-popup" class="sports-path-popup">
               </ul>

               <ul class="sports-side-menu-list">
                  <li   ><a id="sub_menu_detail" href="/exchange/play/myprofile">My Profile</a></li>
                  <li   ><a id="sub_menu_summary" href="/exchange/play/balance" >Balance Overview</a></li>
                  <li   ><a id="sub_menu_accountCashStatement_log" href="/exchange/play/AccountStatement" class="select">Account Statement
                  </a></li>
                  <li   ><a id="sub_menu_my_bets" href="/exchange/play/mybets">My Bets</a></li>
                  <li   ><a id="sub_menu_activity_log" href="/exchange/play/activitylog">Activity Log</a></li>
                  <li   ><a id="sub_menu_activity_log" onClick={props.handlepassmodel} >Change password</a></li>
               </ul>
            </div>
         </div>

         <div class="centar-content report" >





            <div id="message" class="message-content success">
               <a class="close-button">Close</a>

            </div>

            <h2   >Account Statement</h2>

            <table id="table_log" class="table01">
               <tbody><tr>
                  <th width="15%" class="align-L">Date/Time</th>
                  <th width="18%">Deposit</th>
                  <th width="18%">Withdraw</th>
                  <th width="18%">Balance</th>
                  <th width="16%">Remark</th>
                  <th width="">From/To</th>
               </tr>

               </tbody>
               <tbody id="content">
                  {accountStatement.map(function (item, index) {

                     var obj1;
                     var obj2;
                     if (item.coin >= 0) {
                        obj1 = parseFloat(item.coin).toFixed(2);
                        obj2 = '-';
                     }
                     if (item.coin < 0) {
                        obj1 = '-';
                        obj2 = parseFloat(item.coin).toFixed(2);
                     }
                     var obj3 = parseFloat(item.creditLimit).toFixed(2);

                     return (
                        <tr id="tempTr" key={index}>
                           <td id="createDate" class="align-L">{item.currTime}</td>
                           <td id="deposit"> {obj1}</td>
                           <td id="withdraw">{obj2}</td>
                           <td id="balance"> {obj3}</td>
                           <td id="remark"></td>
                           <td   >
                              <spen id="from">Master Agent</spen>
                              <img class="fromto" src={Transparent} />
                              <spen id="to">{item.agentId}</spen>
                           </td>
                        </tr>
                     )
                  })}
               </tbody>
            </table>

            <div   >

               <ul id="pageNumberContent" class="pages">
                  <li id="prev">
                     <a href="javascript:void(0);" class="disable" style={{ pointerEvents: "none" }}>Prev</a></li>
                  <li id="pageNumber">
                     <a href="javascript:void(0);" class="select" style={{ pointerEvents: "none" }}>1</a></li>
                  <li id="next"><a href="javascript:void(0);" class="disable" style={{ pointerEvents: "none" }}>Next</a></li></ul>
            </div>
         </div>
      </React.Fragment>
   )
}
